module.exports = __webpack_public_path__ + "static/media/button-start.68033cdc.png";